import React from 'react';

export const text = (
	<span>
		<h2 className="text-center">
			{`Historien om Ignaz Semmelweis – «mödrarnas frälsare»`}
		</h2>
		<p>
			<strong>
				{`Den österrikisk-ungerske läkaren Ignaz Semmelweis (1818–1865) är känd för att ha
påvisat sambandet mellan läkares bristande handhygien och förekomst av
barnsängsfeber. Genom att införa enkel handtvätt fick han dödligheten bland nyblivna
mödrar att minska drastiskt. Han blev därför känd som «mödrarnas frälsare».`}
			</strong>
		</p>
		<p>
			{`Barnsängstiden omfattar de första 10–14 dagarna efter förlossningen. Efter förlossning
och avslutad graviditet sker stora förändringar i kroppen, och under denna period kan
nyblivna mödrar få feber. I vissa fall håller febern i sig i flera dygn, och då används
benämningen barnsängsfeber. Barnsängsfeber har förekommit i alla tider. I dag vet man
att barnsängsfeber orsakas av en bakteriell infektion i livmodern som uppstår under eller
efter förlossningen, och att infektionen kan behandlas med antibiotika. Så har det dock
inte alltid varit. Det var länge en allmän uppfattning att barnsängsfeber var epidemisk
och orsakades av påverkan bortom människans kontroll så som skadlig atmosfär.
Sådana tillstånd kunde man inte göra något åt, och man antog därför att sjukdomen var
oundviklig.`}
		</p>
		<p>
			{`Under första halvan av 1800-talet byggdes sjukhus i de flesta stora städer i Europa. Även
om det fortfarande var vanligast att föda hemma, blev det allt vanligare att föda på
sjukhus. Det var ofta kvinnor med komplicerade graviditeter och ogifta kvinnor som
födde på sjukhus. Samtidigt som antalet förlossningar på förlossningskliniker ökade,
skedde en betydande ökning av förekomsten av barnsängsfeber. Dödligheten bland
kvinnor som födde på sjukhus var så hög som 25–30 procent på vissa ställen.`}
		</p>
		<p>
			{`Ignaz Semmelweis tog medicinsk examen vid Wiens universitet 1844 och specialiserade
sig inom förlossningsvård. År 1846 började han arbeta som läkare vid
förlossningskliniken i Wien. Kliniken, som användes för att utbilda både läkare och
barnmorskor, var indelad i två avdelningar. Avdelning 1, där läkarna arbetade, användes
för undervisning av läkarstudenter. Avdelning 2, där barnmorskorna arbetade, användes
för utbildning av barnmorskestudenter. Kvinnor från överklassen lades som regel in på
avdelning 1 och följdes av läkare under förlossningen, medan fattiga kvinnor lades in på
avdelning 2 och förlöstes av barnmorskor.`}
		</p>
		<p>
			{`Semmelweis blev förskräckt när han upptäckte att dödligheten var mycket högre på den
ena avdelningen än på den andra. På avdelning 1 dog 18 procent av kvinnorna i
barnsängsfeber, jämfört med endast 2 procent på avdelning 2. Han samlade in uppgifter
och skapade ett diagram som visade antalet dödsfall i barnsängsfeber på de två
avdelningarna under de senaste åren. Semmelweis undrade om skadlig atmosfär var
orsaken till barnsängsfeber – hur kunde detta bara drabba den ena avdelningen och inte
den andra?`}
		</p>
		<p>
			{`	Semmelweis arbetade systematiskt för att ta reda på varför så många kvinnor dog på
första avdelningen efter förlossningar utan komplikationer. Han undersökte alla möjliga
skillnader mellan de två avdelningarna. Han uteslöt patienttätheten som en möjlig
förklaring eftersom det fanns fler kvinnor i rummen på avdelning 2. Det stod också
snabbt klart att de manliga läkarstudenterna inte undersökte de födande kvinnorna på
ett mer hårdhänt sätt än de kvinnliga barnmorskorna.`}
		</p>
		<p>
			{`Kunde det finnas psykologiska förklaringar till skillnaderna mellan de två avdelningarna?
Prästen måste nämligen gå igenom fem förlossningsrum på avdelning 1 för att nå
sjuksalen där en döende kvinna fick den sista smörjelsen. På avdelning 2 kunde han
emellertid gå direkt till sjuksalen utan att passera några förlossningsrum. Semmelweis
ville ta reda på om synen av prästen och ljudet av klockan som ringde innan han gick in i
ett förlossningsrum gjorde kvinnorna oroliga och därmed mer mottagliga för
barnsängsfeber. Han övertalade prästen att ta en omväg och tog bort klockan så att
prästen obemärkt kunde gå till sjuksalen. Men dödligheten på avdelning 1 minskade
inte.`}
		</p>
		<p>
			{`Kunde skillnaderna mellan avdelningarna bero på förlossningsställningen? Semmelweis
fick tips om att kvinnorna på avdelning 2 födde i sidoläge, medan de på avdelning 1
födde liggande på rygg. Han lät införa en regel om att kvinnorna på avdelning 1 också
skulle föda i sidoläge. Men inte heller detta ledde till minskad dödlighet.`}
		</p>
		<p>
			{`Det stora genombrottet kom när Semmelweis kollega och nära vän, Jakob Kolletscha,
skar sig i fingret under obduktionen av en kvinna som hade dött i barnsängsfeber.
Kolletscha fick en infektion och utvecklade samma symtom som kvinnor med
barnsängsfeber. Han dog kort därefter. Detta fick Semmelweis att misstänka ett
samband mellan obduktioner och barnsängsfeber. På avdelning 1 började nämligen
läkarna och läkarstudenterna dagen med att utföra obduktioner innan de övergick till att
arbeta med födande kvinnor. Barnmorskorna på avdelning 2 deltog inte i några
obduktioner och därmed undvek de också att få den karakteristiska lukten av
”likämnen” på sina händer. Semmelweis beordrade därför studenter och kollegor att
tvätta sina händer och instrument med klorkalk efter att ha arbetat med de döda
kvinnokropparna. Denna åtgärd innebar att dödstalen sjönk drastiskt under kort tid, och
snart var förekomsten av barnsängsfeber lägre på avdelning 1 än på avdelning 2.
Semmelweis drog slutsatsen att ”likämnen”, som fastnat på händerna under obduktion,
fördes in i kvinnornas buk när de undersöktes under förlossningen.`}
		</p>

		<p>
			{`Även om åtgärden hade stor effekt var barnsängsfebern fortfarande inte helt utrotad.
Semmelweis observerade att kvinnor kunde få barnsängsfeber även om läkarna inte
hade utfört en obduktion tidigare under dagen, och även om de hade tvättat händerna
med klorkalk efter en obduktion. En dag, efter att ha tvättat händerna noggrant,
undersökte Semmelweis och hans kollegor en kvinna som var sjuk i barnsängsfeber.
Efter denna undersökning undersökte de tolv helt friska kvinnor, utan att tvätta händerna
däremellan. Elva av de tolv kvinnorna fick barnsängsfeber kort därefter och dog. Detta
fick Semmelweis att misstänka att sjukdomen inte enbart orsakades av ”likämnen”,
utan att den också kunde överföras genom ”ruttna ämnen” från levande personer som
hade fastnat på studenternas och läkarnas händer.`}
		</p>

		<p>
			{`Hur infektioner överförs mellan människor var inte klarlagt vid den tidpunkt då
Semmelweis drog sina slutsatser. Men hans fynd blev grunden för modern bakteriologi
många år senare. Även om Semmelweis lyckades minska dödligheten genom att införa
handtvätt, möttes hans teorier med stor skepsis. Han uppfattades vara något av en
bråkstake.`}
		</p>

		<p>
			{`Efter en bitter strid med sjukhusledningen avskedades han. Många av hans kollegor
vägrade erkänna att barnsängsfeber kunde överföras genom direktkontakt mellan
människor. De accepterade inte att de själva kunde vara orsaken till många dödsfall. De
hade ett heligt yrke och kunde omöjligt ha smutsiga händer som tog liv. Semmelweis
blev hånad och förlöjligad för sina påståenden. Han blev tillslut tvångsintagen på ett
mentalsjukhus, där han senare dog.`}
		</p>
	</span>
);
export default text;
